/**
 * 詳情頁快取（客戶、商機），依 id 分開存在 localStorage
 * - 先顯示上次的資料、背景向後端更新（不管多久以前存的；同 PM useProject）；只有沒看過的才顯示載入中
 * - 只留最近看過的 20 筆，避免 localStorage 越存越大
 * - 換帳號時 ensureCacheOwner 會清掉 localStorage，不會看到上一個帳號的資料
 */
const MAX_ENTRIES = 20;

export function createDetailCache<T extends object>(storageKey: string) {
  type Entry = Partial<T> & { timestamp: number };

  const readAll = (): Record<string, Entry> => {
    try {
      return JSON.parse(localStorage.getItem(storageKey) || '{}');
    } catch {
      return {};
    }
  };

  return {
    get: (id?: string): Partial<T> | undefined => (id ? readAll()[id] : undefined),
    /** 合併更新這一筆（例：只更新任務），並把它排到最近 */
    set: (id: string, patch: Partial<T>) => {
      try {
        const all = readAll();
        all[id] = { ...all[id], ...patch, timestamp: Date.now() };
        const recent = Object.entries(all).sort(([, a], [, b]) => b.timestamp - a.timestamp).slice(0, MAX_ENTRIES);
        localStorage.setItem(storageKey, JSON.stringify(Object.fromEntries(recent)));
      } catch { /* localStorage 不可用或已滿時只是不快取 */ }
    },
  };
}
